import { Box, Card, Typography } from '@mui/material';
import { FC } from 'react';

interface MinutesProgressTooltipProp {
  careNoteMinutes: number;
  activityLogMinutes: number;
}

export const MinutesProgressTooltip: FC<MinutesProgressTooltipProp> = ({
  careNoteMinutes,
  activityLogMinutes,
}) => {
  return (
    <Card
      sx={{
        px: '12px',
        minWidth: '180px',
        borderRadius: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 1,
        }}
      >
        <Box
          sx={{
            width: '6px',
            height: '6px',
            bgcolor: theme => theme.palette.secondary.main,
          }}
        />
        <Typography variant='body2' sx={{ flex: 1, m: '0 8px' }}>
          Care notes
        </Typography>
        <Typography variant='subtitle2'>{careNoteMinutes}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 1,
        }}
      >
        <Box
          sx={{
            width: '6px',
            height: '6px',
            bgcolor: theme => theme.palette.primary.main,
          }}
        />
        <Typography variant='body2' sx={{ flex: 1, m: '0 8px' }}>
          Activity log
        </Typography>
        <Typography variant='subtitle2'>{activityLogMinutes}</Typography>
      </Box>
    </Card>
  );
};
